import { RouteObject, Navigate } from "react-router-dom";
import EditTitle from "~@/pages/EditTitle";
import EditPrice from "~@/pages/EditPrice";
import ErrorPage from "~@/pages/ErrorPage";
import Login from "~@/pages/Login";
import ProductList from "~@/pages/ProductList";
import EditFareTemplate from "~@/pages/EditFareTemplate";
import EditiProductStatus from "~@/pages/EditiProductStatus";
import EditStock from "~@/pages/EditStock";
import TaskList from "~@/pages/TaskList";

export type RouteType = RouteObject & {
  layout?: ((props: any) => JSX.Element) | null;
};

export const RouterMap = {
  Home: {
    path: "/",
    label: undefined,
    element: <Navigate to="/products" replace={true} />,
  },
  PRODUCT: {
    path: "/products",
    label: "商品列表",
    element: <ProductList />,
  },
  EidtTitle: {
    path: "/batch-editTitle",
    label: "批量修改标题",
    element: <EditTitle />,
  },
  EidtPrice: {
    path: "/batch-editPrice",
    label: "批量修改价格",
    element: <EditPrice />,
  },
  EditFareTemplate: {
    path: "/batch-editFareTemplate",
    label: "批量修改运费模板",
    element: <EditFareTemplate />,
  },
  EditiProductStatus: {
    path: "/batch-editProductStatus",
    label: "批量修改上下架",
    element: <EditiProductStatus />,
  },
  EditStock: {
    path: "/batch-editStock",
    label: "批量修改库存",
    element: <EditStock />,
  },
  TaskList: {
    path: "/task-list",
    label: "任务列表",
    element: <TaskList />,
  },
  // SHOP_BIND: {
  //   path: "/shopBind",
  //   label: "店铺绑定",
  //   element: <ShopBind />,
  // },
  LOGIN: {
    path: "/login",
    label: "登录",
    element: <Login />,
    layout: null,
  },
  ERROR: { path: "*", label: "404", element: <ErrorPage /> },
};

export const Routers: RouteType[] = Object.entries(RouterMap).map(
  ([key, value]) => value
);
